export default __webpack_public_path__ + "static/media/nft_left_popup.5faca1d6.svg";